import { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { SiteContentContext } from '../context/SiteContentContext';
import Icon from './Icon';
import '../styles/price_popup.css';

// Автоматически всплывает когда на странице есть цена.
// Показывается один раз за сессию (sessionStorage).
const PriceBanner = ({ isPreview = false }) => {
  const { content } = useContext(SiteContentContext);
  const [visible, setVisible] = useState(false);

  const pricingPath = isPreview ? '/preview/pricing' : '/pricing';
  const popupText = content.pricePopupText || 'Цена окончательная — никаких скрытых платежей и доборов на месте.';
  const popupLink = content.pricePopupLinkText || 'Подробнее о ценах';

  useEffect(() => {
    if (sessionStorage.getItem('priceBannerDismissed')) return;
    const t = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    setVisible(false);
    sessionStorage.setItem('priceBannerDismissed', '1');
  };

  if (!visible) return null;

  return (
    <>
      {/* Мобиль: нижний sheet */}
      <div className="price-banner-overlay" onClick={dismiss} />
      <div className="price-banner">
        <div className="price-banner-inner">
          <div className="price-banner-handle" />
          <button className="price-banner-close" onClick={dismiss} aria-label="Скрыть">✕</button>
          <div className="price-banner-icon"><Icon name="shield" size={26} /></div>
          <h3>Прозрачные цены</h3>
          <p>{popupText}</p>
          <Link to={pricingPath} className="price-banner-link" onClick={dismiss}>
            {popupLink} →
          </Link>
        </div>
      </div>
    </>
  );
};

export default PriceBanner;
